// extracted by mini-css-extract-plugin
export default {"title":"MainMenuSection_title__fPMRZ","title_collapsed":"MainMenuSection_title_collapsed__-CxWS"};